<template>
  <div>
    <div id="app">
      <img alt="Vue logo" src="./assets/logo.png">
      <h3>Vue Loading</h3>
      <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
      <div class="vue-loading-form">
        <hr>
        <div class="form-group">
          <label for="bg">Background color</label>
          <input type="text"
                 id="bg"
                 placeholder="Background color"
                 v-model="options.bg"
                 class="form-control"/>
        </div>
        <div class="form-group">
          <label for="icon">Icon</label>
          <input type="text"
                 id="icon"
                 placeholder="Fontawesome Icon"
                 v-model="options.icon"
                 class="form-control"/>
        </div>
        <div class="form-group">
          <label for="size">Size</label>
          <select name="size"
                  v-model="options.size"
                  id="size"
                  class="form-control">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
        <div class="form-group">
          <label for="icon-color">Icon color</label>
          <input type="text"
                 id="icon-color"
                 placeholder="Icon color"
                 v-model="options.icon_color"
                 class="form-control"/>
        </div>
        <div class="form-group">
          <button @click="handleLoading" class="btn btn-primary">Show Loading</button>
        </div>
      </div>
    </div>
    <div class="loading"
         :style="`background-color: ${options.bg};`"
         v-show="isLoading">
      <template v-if="options.slot">
        <div v-html="options.slot"></div>
      </template>
      <template v-else>
        <i :class="`fa fa-${options.icon} fa-pulse fa-${options.size}x fa-fw`"
           :style="`color: ${options.icon_color}`"></i>
        <span class="sr-only">Loading...</span>
      </template>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data () {
    return {
      isLoading: false,
      options: {
        bg: '#41b883ad',
        icon: 'refresh',
        icon_color: 'white',
        size: 3
      }
    }
  },
  methods: {
    handleLoading() {
      this.isLoading = true
      const delay = () => new Promise(resolve => setTimeout(resolve, 3000))
      delay().then(() => this.isLoading = false)
    }
  }
}
</script>

<style>
@import "~font-awesome/css/font-awesome.min.css";
@import "https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css";
@import 'https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap';

#app {
  font-family: Raleway, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  padding: 25px;
}

.vue-loading-form {
  width: 450px;
  margin: 0 auto;
}

.loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 99999 !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading i {
  position: absolute;
  opacity: 1;
}
</style>
